/* global require */
import { createApp } from 'vue'
import anime from 'animejs'
import Modal from './components/Modal'
import Minit from './components/Minit'
import Devolver from './components/Devolver'
import Everyone from './components/Everyone'
const ScrollMagic = require('ScrollMagic')
require('debug.addIndicators')

// == STYLES
import 'normalize.css'
import '../src/styles/main.scss'

// == OCEAN AND WAVES
let ocean = {
  container: null,
  width: null,
  height: null,
  array: [],
  count: 90
}

// == HELPERS
const date = new Date().getTime()
window.detectMobile = function() {
  let check = false
  // eslint-disable-next-line
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
}
function detectIE() {
  let ua = window.navigator.userAgent
  // == IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)'
  // == IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko'
  // == Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0'
  // == Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586'
  const msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // == IE 10 or older
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }
  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // == IE 11
    const rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }
  const edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // == Edge (IE 12+)
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }
  // == other browser
  return false
}

function repositionWave() {
  if (!this) return
  this.style.left = this.x + 'px'
  this.style.top = this.y + 'px'
  this.style.animationDelay = this.animationDelay + 's'
}

function destroyWave() {}

function getRandomNumberBetween(min, max) {
  return Math.floor(min + Math.random() * (max - min))
}

function findClosestNumberDivisibleBy(n, target) {
  return Math.round(target / n) * n
}

function Wave(target) {
  const min = 0
  const max = 15 
  this.reposition = repositionWave
  this.destroy = destroyWave
  this.parent = target.container
  this.element = document.createElement('div')
  this.element.className = 'sprite wave'
  this.style = this.element.style
  // console.log('target w / h', target.width, target.height)
  const cols = findClosestNumberDivisibleBy(64, target.width)/64
  const rows = findClosestNumberDivisibleBy(64, target.height)/64
  const rCol = getRandomNumberBetween(0, cols)
  const rRow = getRandomNumberBetween(0, rows)
  this.x = rCol * 64
  this.y = rRow * 64
  // console.log('cols, rows', cols, rows)
  // console.log('rCol, rRow', rCol, rRow)
  // console.log('target pos', this.x, this.y)
  this.animationDelay = Math.floor(Math.random() * (max - min + 1)) + min
  this.reposition()
  this.parent.appendChild(this.element)
}

function makeWaves(target) {
  let c = target.count
  while (c--) {
    target.array[target.count] = new Wave(target)
    target.count++
  }
}

const app = createApp({
  components: { Modal, Minit, Devolver, Everyone },
  // == DATA
  data() {
    return {
      debug: 0,
      controller: null,
      walking: false,
      dead: false,
      outside: false,
      houseProgress: null,
      islandProgress: null,
      oceanProgress: null,
      diedAtProgress: null,
      diedInside: null,
      onBoat: false,
      onIsland: false,
      scale: 4,
      oceanForwardOffset: 0.065,
      oceanReverseOffset: 0.065,
      oceanForwardStart: 0.310, // 0.460
      oceanReverseStart: 0.380,
      descriptionVisible: true,
      doorThreshold: 0.158,
      seagullThreshold: 0.600, // 0.818
      seagullScared: false,
      rockThreshold: 0,
      showModal: false,
      dogSleeps: Math.random() >= 0.5,
      dither: '/static/dither-out-once.gif?' + date
    }
  },
  // == LIFECYCLE
  beforeCreate() {
    // console.log('vue - beforeCreate')
    // == RESET SCROLL ON LOAD / REFRESH
    window.onbeforeunload = () => {
      window.scrollTo(0, 0)
    }
  },
  created() {
    // console.log('vue - created')
    if (this.controller === null)
      this.controller = new ScrollMagic.Controller({
        loglevel: this.debug
      })
    // window.addEventListener('scroll', this.handleScroll)
  },
  beforeMount() {
    // console.log('vue - beforeMount')
  },
  mounted() {
    // console.log('vue - mounted')
    const vm = this
    this.$nextTick(() => {
      if (detectIE() || window.detectMobile) {
        vm.$refs.dither.classList.add('hidden')
      }
      vm.setup()
    })
    // == SPIN UP OCEAN WAVES
    ocean.container = vm.$refs.waves
    ocean.width = ocean.container.clientWidth
    ocean.height = ocean.container.clientHeight
    makeWaves(ocean)
    // == SPIN UP ISLAND WAVES
    // island.container = vm.$refs.island
    // island.width = ocean.container.clientWidth
    // island.height = ocean.container.clientHeight
    // makeWaves(island)
  },
  beforeUpdate() {
    // console.log('vue - beforeUpdate')
  },
  updated() {
    // console.log('vue - updated')
  },
  beforeUnmount() {},
  unmounted() {
    // console.log('vue - unmounted')
    this.controller.destroy(true)
    this.controller = null
    // window.removeEventListener('scroll', this.handleScroll)
  },
  // == METHODS
  methods: {
    goto: function (url, target) {
      const t = target ? target : '_self'
      window.open(url, t)
    },
    handleScroll: function () {
      // console.log('vue - handleScroll')
    },
    setup() {
      const vm = this
      // console.log('vue - setup')
      // eslint-disable-next-line
      const chimneySmoke = anime({
        targets: '#chimney-smoke-one',
        translateX: 24,
        translateY: -82,
        easing: 'linear',
        duration: 2000,
        loop: true
      })
      if (vm.dogSleeps) {
        vm.$refs.dog.classList.add('sleep')
        vm.$refs.dog.classList.remove('idle')
        vm.$refs.dog.classList.remove('right')
      } else {
        const dogTimeline = anime.timeline({
          easing: 'linear'
        })
        dogTimeline
          // == WALK RIGHT, STOP
          .add({
            begin: function () {
              vm.$refs.dog.classList.add('walk')
              vm.$refs.dog.classList.remove('idle')
            },
            targets: '#dog',
            translateX: '100px',
            translateY: '50px',
            duration: 2100,
            delay: 1000,
            complete: function () {
              vm.$refs.dog.classList.add('idle')
              vm.$refs.dog.classList.remove('walk')
            }
          })
          // == STAND STILL, FLIP
          .add({
            begin: function () {
              vm.$refs.dog.classList.add('left')
              vm.$refs.dog.classList.remove('right')
            },
            targets: '#dog',
            duration: 1100
          })
          // == WALK LEFT, STOP, FLIP
          .add({
            begin: function () {
              vm.$refs.dog.classList.add('walk')
              vm.$refs.dog.classList.remove('idle')
            },
            targets: '#dog',
            translateX: '-12px',
            translateY: '-4px',
            duration: 2100,
            complete: function () {
              vm.$refs.dog.classList.add('idle')
              vm.$refs.dog.classList.remove('walk')
              vm.$refs.dog.classList.add('right')
              vm.$refs.dog.classList.remove('left')
            }
          })
          // == WALK RIGHT, STOP
          .add({
            begin: function () {
              vm.$refs.dog.classList.add('walk')
              vm.$refs.dog.classList.remove('idle')
            },
            targets: '#dog',
            translateX: '100px',
            translateY: '50px',
            duration: 2100,
            delay: 1000,
            complete: function () {
              vm.$refs.dog.classList.add('idle')
              vm.$refs.dog.classList.remove('walk')
            }
          })
          // == STAND STILL, FLIP
          .add({
            begin: function () {
              vm.$refs.dog.classList.add('left')
              vm.$refs.dog.classList.remove('right')
            },
            targets: '#dog',
            duration: 1100
          })
          // == WALK LEFT, STOP, SLEEP
          .add({
            begin: function () {
              vm.$refs.dog.classList.add('walk')
              vm.$refs.dog.classList.remove('idle')
            },
            targets: '#dog',
            translateX: '-8px',
            translateY: '-4px',
            duration: 2100,
            complete: function () {
              vm.$refs.dog.classList.add('sleep')
              vm.$refs.dog.classList.remove('walk')
              vm.$refs.dog.classList.add('right')
              vm.$refs.dog.classList.remove('left')
            }
          })
      }
      // eslint-disable-next-line
      const walkingCrabOne = anime({
        targets: '#crab-one',
        translateX: 378,
        easing: 'linear',
        duration: 3600,
        direction: 'alternate',
        loop: true
      })
      // eslint-disable-next-line
      const walkingCrabTwo = anime({
        targets: '#crab-two',
        translateX: 142,
        easing: 'linear',
        duration: 1355,
        direction: 'alternate',
        loop: true
      })
      // eslint-disable-next-line
      const walkingCrabThree = anime({
        targets: '#crab-three',
        translateX: 378,
        easing: 'linear',
        duration: 3600,
        direction: 'alternate',
        loop: true
      })
      // eslint-disable-next-line
      const scooter = anime({
        targets: '#scooter',
        translateX: 0,
        easing: 'linear',
        duration: 3600,
        direction: 'alternate',
        loop: true
      })
      // eslint-disable-next-line
      const boatIdle = anime.timeline({
        targets: '#boat',
        elasticity: 0,
        loop: true
      })
      boatIdle
        .add({
          translateY:  0,
          duration: 350,
          delay: 0,
        })
        .add({
          translateY: 4,
          duration: 350,
          delay: 0,
        })
        .add({
          translateY: 8,
          duration: 350,
          delay: 0,
        })
        .add({
          translateY: 8,
          duration: 350,
          delay: 0,
        })
        .add({
          translateY: 4,
          duration: 350,
          delay: 0,
        })
        .add({
          translateY:  0,
          duration: 350,
          delay: 0,
        })
      // eslint-disable-next-line
      const boatRowing = anime.timeline({
        targets: '#boat',
        elasticity: 0,
        loop: true
      })
      boatRowing
        .add({
          translateX: 0,
          duration: 350,
          delay: 0,
        })
        .add({
          translateX: 8,
          duration: 350,
          delay: 0,
        })
        .add({
          translateX: 16,
          duration: 350,
          delay: 0,
        })
        .add({
          translateX: 16,
          duration: 350,
          delay: 0,
        })
        .add({
          translateX: 8,
          duration: 350,
          delay: 0,
        })
        .add({
          translateX: 0,
          duration: 350,
          delay: 0,
        })
      // eslint-disable-next-line
      const seagullFlying = anime({
        targets: '#seagull',
        translateX: 1000,
        translateY: -1000,
        duration: 1680,
        delay: 0,
        elasticity: 0,
        easing: 'easeInSine',
        loop: false,
        autoplay: false,
        complete: function () {
          vm.$refs.seagull.classList.add('hidden')
        }
      })
      // eslint-disable-next-line
      const sceneHouse = new ScrollMagic.Scene({
          triggerElement: '#walk',
          triggerHook: 'onCenter',
          duration: 948, // 1024,
          loglevel: vm.debug
        })
        .addTo(vm.controller)
        // .addIndicators({
        //   name: 'house'
        // })
        .setPin('#player', {
          pushFollowers: false
        })
        // eslint-disable-next-line
        .on('start', function (e) {
          // setTimeout(() => {
          //   vm.dead = true
          //   if (vm.diedAtProgress === null) vm.diedAtProgress = vm.houseProgress
          //   if (vm.diedInside === null) vm.diedInside = vm.diedAtProgress < vm.doorThreshold
          //   sceneHouse.removePin()
          // }, 60000)
        })
        // eslint-disable-next-line
        .on('enter leave', function (e) {
          switch (e.type) {
            case 'enter':
              // console.log('entered')
              vm.onBoat = false
              boatIdle.play()
              boatRowing.pause()
              if (!vm.walking) vm.walking = true
              break
            case 'leave':
              // console.log('left')
              vm.onBoat = true
              boatIdle.pause()
              boatRowing.play()
              if (vm.walking) vm.walking = false
              break
          }
        })
        // eslint-disable-next-line
        .on('progress', function (e) {
          vm.houseProgress = e.progress.toFixed(3)
          // console.log('vm.houseProgress', vm.houseProgress)
          // == EXITING HOUSE...
          if (vm.houseProgress >= vm.doorThreshold) {
            vm.$refs.house.classList.add('outside')
            vm.$refs.shore.classList.remove('hidden')
            vm.$refs.waves.classList.remove('hidden')
            vm.$refs.topbar.classList.add('bordered')
            vm.outside = true
          } else if (vm.houseProgress < vm.doorThreshold) {
            vm.$refs.house.classList.remove('outside')
            vm.$refs.shore.classList.add('hidden')
            vm.$refs.waves.classList.add('hidden')
            vm.$refs.topbar.classList.remove('bordered')
            vm.outside = false
          }
          // == SEAGULL FLIES AWAY...
          if (vm.houseProgress >= vm.seagullThreshold) {
            seagullFlying.play()
            vm.seagullScared = true
          }
        })
      // eslint-disable-next-line
      const sceneOcean = new ScrollMagic.Scene({
        triggerElement: '#edge',
        triggerHook: 'onCenter',
        duration: 2091,
          loglevel: vm.debug
        })
        .addTo(vm.controller)
        // .addIndicators({
        //   name: 'ocean'
        // })
        .setPin('#boat', {
          pushFollowers: false
        })
      // eslint-disable-next-line
      const sceneDescription = new ScrollMagic.Scene({
        triggerElement: '#ocean',
        triggerHook: 'onCenter',
        duration: 1000,
        loglevel: vm.debug
      })
      .addTo(vm.controller)
        // .addIndicators({
          // name: 'desc'
        // })
        .on('progress', function (e) {
          vm.descProgress = e.progress.toFixed(3)
          // console.log('vm.descProgress', vm.descProgress)
          // == NAVIGATING THROUGH OCEAN...
          if (e.scrollDirection === 'FORWARD') {
            // if (vm.descProgress > vm.oceanForwardStart + (vm.oceanForwardOffset * 0)) { vm.$refs.desc01.classList.add('hidden') }
            // if (vm.descProgress > vm.oceanForwardStart + (vm.oceanForwardOffset * 1)) { vm.$refs.desc02.classList.add('hidden') }
            // if (vm.descProgress > vm.oceanForwardStart + (vm.oceanForwardOffset * 2)) { vm.$refs.desc03.classList.add('hidden') }
            // if (vm.descProgress > vm.oceanForwardStart + (vm.oceanForwardOffset * 3)) { vm.$refs.desc04.classList.add('hidden') }
            // if (vm.descProgress > vm.oceanForwardStart + (vm.oceanForwardOffset * 4)) { vm.$refs.desc05.classList.add('hidden') }
            if (vm.descProgress > vm.oceanForwardStart + (vm.oceanForwardOffset * 5)) { vm.$refs.about.classList.remove('visible') }
          } else if (e.scrollDirection === 'REVERSE') {
            // if (vm.descProgress < vm.oceanReverseStart + (vm.oceanReverseOffset * 0.1)) { vm.$refs.desc01.classList.remove('hidden') }
            // if (vm.descProgress < vm.oceanReverseStart + (vm.oceanReverseOffset * 1)) { vm.$refs.desc02.classList.remove('hidden') }
            // if (vm.descProgress < vm.oceanReverseStart + (vm.oceanReverseOffset * 2)) { vm.$refs.desc03.classList.remove('hidden') }
            // if (vm.descProgress < vm.oceanReverseStart + (vm.oceanReverseOffset * 3)) { vm.$refs.desc04.classList.remove('hidden') }
            // if (vm.descProgress < vm.oceanReverseStart + (vm.oceanReverseOffset * 4)) { vm.$refs.desc05.classList.remove('hidden') }
            if (vm.descProgress < vm.oceanReverseStart + (vm.oceanReverseOffset * 5)) { vm.$refs.about.classList.add('visible') }
          }
        })
        .on('start', function (e) {
          // console.log('start', e)
          if (e.scrollDirection === 'FORWARD') {
            // vm.$refs.desc01.classList.remove('hidden')
            // vm.$refs.desc02.classList.remove('hidden')
            // vm.$refs.desc03.classList.remove('hidden')
            // vm.$refs.desc04.classList.remove('hidden')
            // vm.$refs.desc05.classList.remove('hidden')
            // vm.$refs.desc06.classList.remove('hidden')
            vm.$refs.about.classList.add('visible')
          }
          if (e.scrollDirection === 'REVERSE') vm.descriptionVisible = true
        })
      // eslint-disable-next-line
      const sceneIsland = new ScrollMagic.Scene({
          triggerElement: '#rocks',
          triggerHook: 'onCenter',
          offset: '1px',
          duration: 189,
          loglevel: vm.debug
        })
        .addTo(vm.controller)
        // .addIndicators({
          // name: 'island'
        // })
        .setPin('#playerOnIsland', {
          pushFollowers: false
        })
        // eslint-disable-next-line
        .on('progress', function (e) {
          vm.islandProgress = e.progress.toFixed(3)
          // console.log('vm.islandProgress', vm.islandProgress)
          // == ENTERING ISLAND...
          if (vm.islandProgress <= vm.rockThreshold) {
            vm.onIsland = false
          } else if (vm.islandProgress > vm.rockThreshold) {
            vm.onIsland = true
          }
        })
        // eslint-disable-next-line
        .on('enter leave', function (e) {
          switch (e.type) {
            case 'enter':
              // console.log('entered')
              vm.onBoat = false
              boatIdle.pause()
              boatRowing.pause()
              vm.walking = true
              break
            case 'leave':
              // console.log('left')
              if (e.scrollDirection === 'REVERSE') {
                vm.onBoat = true
                boatIdle.pause()
                boatRowing.play()
                vm.walking = false
              } else if (e.scrollDirection === 'FORWARD') {
                vm.walking = false
              }
              break
          }
        })
    }
  }
})

app.mount('#app')
